import React from 'react'
import { type ICarePlanCardProps } from '../../../../interfaces/careplan.interface'
import SurveyRangeItem from '../RangeItems/SurveyRangeItem'

export default function SymptomSurveyCard (props: ICarePlanCardProps): JSX.Element {
  return (
    <div className='care-plan__section' data-testid='care-plan__section__survey'>
      <div className='care-plan__section-header'>Symptom Survey</div>
      <SurveyRangeItem {...props} />
    </div>
  )
}
